import Vue from "vue";
import VueRouter from "vue-router";

Vue.use(VueRouter);

// 解决点击重复路由的问题
const originalPush = VueRouter.prototype.push;
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch((err) => err);
};

const routes = [
  {
    path: "/",
    name: "notion",
    meta: {
      title: "用户须知",
      listen: true,
      show: false,
    },
    component: () => import("../views/notice.vue"),
  },
  {
    path: "/login",
    name: "login",
    meta: {
      title: "登录",
      listen: true,
      show: false,
    },
    component: () => import("../views/login.vue"),
  },
  {
    path: "/reg",
    name: "reg",
    meta: {
      title: "注册",
      listen: false,
      show: true,
    },
    component: () => import("../views/reg.vue"),
  },
  {
    path: "/forget",
    name: "forget",
    meta: {
      title: "忘记密码",
      listen: false,
      show: true,
    },
    component: () => import("../views/forget.vue"),
  },
  {
    path: "/create",
    name: "create",
    meta: {
      title: "学生信息",
      listen: false,
      btns: ["002"],
      show: false,
    },
    component: () => import("../views/create.vue"),
  },
  {
    path: "/choose",
    name: "choose",
    meta: {
      title: "学生信息创建",
      listen: false,
      btns: ["002"],
      show: true,
    },
    component: () => import("../views/choose.vue"),
  },
  {
    path: "/p-register",
    name: "p-register",
    meta: {
      title: "信息填报",
      listen: true,
      btns: ["002"],
      show: true,
    },
    component: () => import("../views/p-register.vue"),
  },
  {
    path: "/p-r-upload",
    name: "p-r-upload",
    meta: {
      title: "信息填报",
      listen: true,
      btns: ["002"],
      show: true,
    },
    component: () => import("../views/p-r-upload.vue"),
  },
  {
    path: "/property",
    name: "property",
    meta: {
      title: "信息填报",
      listen: true,
      btns: ["002"],
      show: true,
    },
    component: () => import("../views/property.vue"),
  },
  {
    path: "/school",
    name: "school",
    meta: {
      title: "信息填报",
      listen: true,
      btns: ["002"],
      show: true,
    },
    component: () => import("../views/school.vue"),
  },
  {
    path: "/submit",
    name: "submit",
    meta: {
      title: "信息填报",
      listen: true,
      btns: ["002"],
      show: true,
    },
    component: () => import("../views/submit.vue"),
  },
  {
    path: "/examine",
    name: "examine",
    meta: {
      title: "信息审核",
      listen: true,
      btns: ["002"],
      show: true,
    },
    component: () => import("../views/examine.vue"),
  },
];

const router = new VueRouter({
  routes,
});
router.beforeEach((to, from, next) => {
  // console.log(to);
  // console.log(from);
  // if (to.path == "/" && from.path == "/home") {
  //   let backlen = history.length - 1;
  //   history.go(-backlen);
  // }
  next();
});

export default router;
